import BaseService from './base.service';

class WorkFeedbackService extends BaseService {
  constructor() {
    super();
    this.baseURL = '/work-feedback';
  }

  /**
   * Create a new work feedback
   * @param {Object} workFeedbackData - Data for creating a new work feedback
   * @returns {Promise<Object>} - Promise resolving to the created work feedback
   */
  create(workFeedbackData) {
    return this.post(this.baseURL, workFeedbackData);
  }
}

export default new WorkFeedbackService();
